import {
    RESTART_POLL,
    FETCH_INITIAL_DATA,
    RECEIVED_ENTITIES,
    FETCH_UNAVAILABLE_TIMES,
    SET_UNAVAILABLE_TIMES,
} from '../constants';

export const fetchInitialData = () => {
    return {
        type: FETCH_INITIAL_DATA
    };
};

export const receivedEntities = (entities) => {
    return {
        type: RECEIVED_ENTITIES,
        entities,
    };
};

export const restartPoll = () => {
    return {
        type: RESTART_POLL,
    };
};

export const fetchUnavailableTimes = (versionedUId, staticUId, showLoading = true) => {
    return {
        type: FETCH_UNAVAILABLE_TIMES,
        versionedUId,
        staticUId,
        showLoading,
    };
};

export const setUnavailableTimes = (staticUId, unavailableTimes) => {
    return {
        type: SET_UNAVAILABLE_TIMES,
        staticUId,
        unavailableTimes,
    };
};



// WEBPACK FOOTER //
// ./scripts/actions/entities.js